"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _productAreas = require("@insided/shared/utils/productAreas");

var _ProductAreasDropdown = _interopRequireDefault(require("@insided/shared/modules/ProductAreas/ProductAreasDropdown"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'product-areas-dropdown';
exports.cssAnchorName = cssAnchorName;

var ProductAreaDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductAreaDropdown, _Component);

  var _super = _createSuper(ProductAreaDropdown);

  function ProductAreaDropdown() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductAreaDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "urlParams", typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "productAreaId", _this.urlParams.get('productAreaId'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      internalSelectedIds: _this.productAreaId ? [_this.productAreaId] : []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUpdateProductAreas", function (productAreas) {
      var onChange = _this.props.onChange;
      var selectedPAIds = productAreas.map(function (productArea) {
        return productArea.id;
      }); // Always update internal state when uncontrolled (no value prop)

      if (_this.props.value === undefined) {
        _this.setState({
          internalSelectedIds: selectedPAIds
        });
      }

      onChange === null || onChange === void 0 ? void 0 : onChange(selectedPAIds);
    });
    return _this;
  }

  (0, _createClass2.default)(ProductAreaDropdown, [{
    key: "selectedProductAreaIds",
    get: function get() {
      // Use controlled value if provided, otherwise fall back to internal state
      if (this.props.value !== undefined) {
        return this.props.value;
      }

      return this.state.internalSelectedIds;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          productAreasV2 = _this$props.productAreasV2,
          inputName = _this$props.inputName,
          inputId = _this$props.inputId;
      var selectedProductAreaIds = this.selectedProductAreaIds;
      var productAreas = productAreasV2;
      var normalizedProductAreas = (productAreas === null || productAreas === void 0 ? void 0 : productAreas.length) > 0 ? (0, _productAreas.getNormalizedPAList)(productAreas) : [];
      var selectedProductAreas = (0, _productAreas.getSelectedProductAreas)(selectedProductAreaIds, (0, _productAreas.getNormalizedPAList)(this.props.productAreasV2));
      return (0, _preact.h)("div", {
        className: "product-areas-dropdown"
      }, selectedProductAreaIds !== null && selectedProductAreaIds !== void 0 && selectedProductAreaIds.length ? (0, _preact.h)("input", {
        type: "hidden",
        name: inputName,
        id: inputId,
        value: "".concat(selectedProductAreaIds)
      }) : null, (0, _preact.h)(_ProductAreasDropdown.default, {
        showPhrase: true,
        productAreasV2: normalizedProductAreas,
        closeOnDropdownClick: false,
        onUpdateProductAreas: this.onUpdateProductAreas,
        selectedProductAreas: selectedProductAreas
      }));
    }
  }]);
  return ProductAreaDropdown;
}(_preact.Component);

var _default = ProductAreaDropdown;
exports.default = _default;